<template>
  <!-- <p class="float-end"><a href="#">Back to top</a></p>
    <p>&copy; 2017–2024 Company, Inc. &middot; <a href="#">Privacy</a> &middot; <a href="#">Terms</a></p> -->
  <footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-md-6">
            <div class="footer-info">
              <h3>Doctor in Home<span>.</span></h3>
              <p class="address-text">
  Head Office: A-1406, 32, Digital-ro 9-gil, Geumcheon-gu, Seoul
  <br><br>

  <strong>OTITON MEDICAL CO., LTD.</strong>
  <br><br>

  <strong>Phone:</strong> +82 70 4607 2681<br>
  <strong>Email:</strong> otiton-medical@otiton-medical.com
</p>
              <!-- <div class="social-links mt-3">
                <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
                <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a>
              </div> -->
            </div>
          </div>
          <div class="col-lg-6 col-md-12 d-flex justify-content-end footer-links-wrapper pe-5">
  <div class="col-lg-2 col-md-6 footer-links">
    <h4>About Us</h4>

    <ul>
      <li>
        <i class="bx bx-chevron-right"></i>
        <router-link :to="{ path: '/about', hash: '#about' }">
          About
        </router-link>
      </li>

      <li>
        <i class="bx bx-chevron-right"></i>
        <router-link :to="{ path: '/about', hash: '#contact' }">
          Way to come
        </router-link>
      </li>
    </ul>
  </div>

  <div class="col-lg-3 col-md-6 footer-links">
    <h4>Service</h4>

    <ul>
      <li>
        <i class="bx bx-chevron-right"></i>
        <router-link to="/App">
          APP
        </router-link>
      </li>

      <li>
        <i class="bx bx-chevron-right"></i>
        <router-link to="/notice">
          Announcements
        </router-link>
      </li>

      <li>
        <i class="bx bx-chevron-right"></i>
        <router-link to="/qna">
          Q&amp;A
        </router-link>
      </li>
    </ul>
  </div>
</div>

          <!-- <div class="col-lg-4 col-md-6 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
            <form action="" method="post">
              <input type="email" name="email"><input type="submit" value="Subscribe">
            </form>

          </div> -->

        </div>
      </div>

    </div>
    <div class="container">
      <div class="copyright">
        &copy; Copyright <strong><span>Otiton Medical</span></strong>. All Rights Reserved
      </div>
    </div>
  </footer><!-- End Footer -->
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  color: #444444;
}

a {
  color: #ffc451;
  text-decoration: none;
}

a:hover {
  color: #ffd584;
  text-decoration: none;
}


/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
#footer {
  background: black;
  padding: 0 0 30px 0;
  color: #fff;
  font-size: 14px;
}

#footer .footer-top {
  background: #151515;
  border-bottom: 1px solid #222222;
  padding: 60px 0 30px 0;
}

#footer .footer-top .footer-info {
  margin-bottom: 30px;
}

#footer .footer-top .footer-info h3 {
  font-size: 28px;
  margin: 0 0 20px 0;
  padding: 2px 0 2px 0;
  line-height: 1;
  font-weight: 700;
  text-transform: uppercase;
}

.address-text {
  white-space: nowrap;
  /* ✅ 줄바꿈 방지 */
}

#footer .footer-top .footer-info h3 span {
  color: #ffc451;
}


#footer .footer-top .footer-info p {
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 0;
  color: #fff;
}

#footer .footer-top .social-links a {
  font-size: 18px;
  display: inline-block;
  background: #292929;
  color: #fff;
  line-height: 1;
  padding: 8px 0;
  margin-right: 4px;
  border-radius: 4px;
  text-align: center;
  width: 36px;
  height: 36px;
  transition: 0.3s;
}

#footer .footer-top .social-links a:hover {
  background: #ffc451;
  color: #151515;
  text-decoration: none;
}

#footer .footer-top h4 {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  position: relative;
  padding-bottom: 12px;
}

#footer .footer-top .footer-links {
  margin-bottom: 30px;
}

#footer .footer-top .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

#footer .footer-top .footer-links ul i {
  padding-right: 2px;
  color: #ffc451;
  font-size: 18px;
  line-height: 1;
}

#footer .footer-top .footer-links ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

#footer .footer-top .footer-links ul li:first-child {
  padding-top: 0;
}

#footer .footer-top .footer-links ul a {
  color: #fff;
  transition: 0.3s;
  display: inline-block;
  line-height: 1;
}

#footer .footer-top .footer-links ul a:hover {
  color: #ffc451;
}

#footer .footer-top .footer-newsletter form {
  margin-top: 30px;
  background: #fff;
  padding: 6px 10px;
  position: relative;
  border-radius: 4px;
}

#footer .footer-top .footer-newsletter form input[type=email] {
  border: 0;
  padding: 4px;
  width: calc(100% - 110px);
}

#footer .footer-top .footer-newsletter form input[type=submit] {
  position: absolute;
  top: 0;
  right: -2px;
  bottom: 0;
  border: 0;
  background: none;
  font-size: 16px;
  padding: 0 20px;
  background: #ffc451;
  color: #151515;
  transition: 0.3s;
  border-radius: 0 4px 4px 0;
}

#footer .footer-top .footer-newsletter form input[type=submit]:hover {
  background: #ffcd6b;
}

#footer .copyright {
  text-align: center;
  padding-top: 30px;
}

#footer .credits {
  padding-top: 10px;
  text-align: center;
  font-size: 13px;
  color: #fff;
}

.footer-links-wrapper {
  display: flex;
  gap: 40px;
  margin-left: auto;
  transform: translateX(-400px);
  /* ← ✅ 오른쪽 그룹을 전체 왼쪽으로 당김 */
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .address-text {
    white-space: normal;
  }
}
</style>
